import React from "react";

import { Report } from "./reportLoader";
import { Props } from "./types";
import styles from "./styles.scss";

function Loader(props: Props) {
  return (
    <div className={styles.reportsList}>
      <div className={styles.report}>
        <Report />
      </div>
      <div className={styles.report}>
        <Report />
      </div>
      <div className={styles.report}>
        <Report />
      </div>
      <div className={styles.report}>
        <Report />
      </div>
      <div className={styles.report}>
        <Report />
      </div>
      <div className={styles.report}>
        <Report />
      </div>
      <div className={styles.report}>
        <Report />
      </div>
      <div className={styles.report}>
        <Report />
      </div>
      <div className={styles.report}>
        <Report />
      </div>
      <div className={styles.report}>
        <Report />
      </div>
      <div className={styles.report}>
        <Report />
      </div>
      <div className={styles.report}>
        <Report />
      </div>
      <div className={styles.report}>
        <Report />
      </div>
    </div>
  );
}

export { Loader };
